// 카리아카 lang/locales_old/ko.js 에서 콘솔이 쓰는 문구만 남겼다(교육 문구 790줄은 뺐다).
const strings = {
  modal: {
    title: "알림",
    alert: "알림",
    confirm: "확인",
    ok: "확인",
    no: "취소",
  },
  point_help: "링크를 받지 못하셨나요?",
};

export default strings;
